import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';


export interface Tab {
  id: number;
  label: string;
  routerLink: string;
  isActive: boolean;
  closable: boolean;
  type: string;
}
@Injectable({
  providedIn: 'root'
})
export class DynamicTabsService {
  tabs: Tab[] = [];
  selectedTab: any = '';
  selectedTabData: any = '';
  currentTabId: number = 0;
  currentTabName: string = '';
  constructor(private router: Router, private actRoute: ActivatedRoute) { }
  isCollapsed: boolean = false;
  closableTab!: Tab;
  screen: string = '';
  paramId: number = 0;
  item: any;
  closeTabId!: number;

  
  //save
  private saveSub = new BehaviorSubject<Boolean>(false);
  saveObv = this.saveSub.asObservable();
  saveClicked() {
    this.saveSub.next(sessionStorage.getItem('saveBtn') == 'true');
    console.log(sessionStorage.getItem('saveBtn') === 'true');
    console.log(sessionStorage.getItem('saveBtn') == 'true');
  }

  //delete
  private deleteSub = new BehaviorSubject<Boolean>(false);
  deleteObv = this.deleteSub.asObservable();

  deleteClicked(isDeleted: boolean): void {
    // this.deleteSub.next(isDeleted);
    console.log(sessionStorage.getItem('deleteBtn') === 'true');
    console.log(sessionStorage.getItem('deleteBtn') == 'true');
    this.deleteSub.next(sessionStorage.getItem('deleteBtn') == 'true');
  }

  //refresh

  private refreshSub = new BehaviorSubject<boolean>(false);
  refreshObv = this.refreshSub.asObservable();

  refreshClicked(): void {
    console.log(sessionStorage.getItem('refreshBtn') === 'true');
    console.log(sessionStorage.getItem('refreshBtn') == 'true');
    this.refreshSub.next(sessionStorage.getItem('refreshBtn') == 'true');
  }

  //Renew
  private renewSub = new BehaviorSubject<boolean>(false);
  renewObv = this.renewSub.asObservable();
  setTabs(tabs: Tab[]): void {
    this.tabs = tabs;
  }
  renewClicked() {
    console.log(sessionStorage.getItem('renewBtn') === 'true');
    console.log(sessionStorage.getItem('renewBtn') == 'true');
    this.renewSub.next(sessionStorage.getItem('renewBtn') == 'true');
  }

  //closeTab
  private closeSub = new BehaviorSubject<boolean>(false);
  closeObv = this.closeSub.asObservable();

  closingTab() {
    let subscription = this.closeSub.subscribe(() => { });
    if (subscription.closed)
      this.closeSub.subscribe(() => {})
    console.log(sessionStorage.getItem('closeBtn'));
    this.closeSub.next(sessionStorage.getItem('closeBtn') == 'true');


  }

  getIndexByTab(tabs: Tab) {
    return this.tabs.indexOf(tabs);
  }

  createTabsFromNavbarData(item: any): void {
    this.saveSub.next(false);
    this.tabs.forEach(tab => tab.isActive = false);
    this.selectedTab = item.label;
    this.selectedTabData = item;
    const tabIndex = this.tabs.findIndex(t => t.id === item.id);
    if (tabIndex != -1) {
      this.tabs[tabIndex].isActive = true;
    } else {
      // Open a new tab
      const tabs = {
        id: item.id,
        label: item.label,
        routerLink: item.routerLink,
        type: item.type,
        closable: false,
        isActive: true,
      }
      this.tabs.push(tabs);

    }
  }
  openTab(tab: any): boolean {

    this.tabs.forEach(tab => tab.isActive = false);
    tab.isActive = true;
    // this.tabs.find(tab)!.isActive =true
    if ((tab.type == 'association') || (tab.type == 'policy')) {
      this.currentTabName = tab.label;
      this.currentTabId = tab.id;
    }
    this.selectedTabData = tab;
    this.selectedTab = this.selectedTabData.label;
    return true;
  }
  removeTab(tab: { id: number; label: string; routerLink: string; closable: boolean }): void {
    const tabIndex = this.tabs.findIndex(t => t.routerLink === tab.routerLink);
    if (tabIndex !== -1) {
      this.tabs.splice(tabIndex, 1);
    }
    // if(this.closableTab){
    //   this.closableTab.closable = false
    // }
    
  }

  closeTab(tab: any): void {
    this.closeTabId = tab.id;
    // this.closeSub.unsubscribe();
    if (tab.closable) {
      this.closableTab.closable=false;
      const currentIndex = this.getIndexByTab(tab);
      this.removeTab(tab);
      const actTab: number = this.tabs.filter(t => t.isActive == true).length;
      // If there are remaining tabs, navigate to the previous tab's URL
      const previousTab = this.tabs[currentIndex - 1];
      const nextTab = this.tabs[currentIndex];
      if (previousTab && actTab <= 0) {
        previousTab.isActive = true;
        this.openTab(previousTab);

        // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
      }
      else if (nextTab && actTab <= 0) {
        nextTab.isActive = true;
        this.openTab(nextTab);
      }
      else if (actTab == 0) {
        this.closeTab(actTab);
      }
      // else {
      //   // If no previous tab, navigate to the default URL
      //   this.router.navigate(['/']);
      // }
    }

  }
  closeTabById(id: number): void {
    const tab = this.tabs.find((t) => t.id === id);

    if (tab) {
      if (tab.type === 'policy') {
        this.removeTab(tab);
      }
    }
  }

  detectURL() {
    this.actRoute.queryParams.subscribe(params => {
      this.screen = params["screen"];
      this.paramId = +params["MasterPolicyId"]
      let id = params["UserId"];
      //  sessionStorage.setItem('userId',id);

      if (this.screen == "MasterPolicyDetail") {
        if (this.paramId > 0) {

          this.item = { id: this.paramId, label: "policy details", routerLink: "Policy Details", type: "policy" };
          // this.openDetailTab(this.item);
          this.createTabsFromNavbarData(this.item);
        }
      }
      else if (this.screen == "AssociationAdd") {
        this.item = { id: -7, routerLink: 'AssnAddNew', label: 'Add New' };
        this.createTabsFromNavbarData(this.item);
      }
      else if (this.screen == "AbandonedGoApps") {
        this.item = { id: -11, routerLink: 'guides/abandoned', label: 'Abandoned Apps' };
        this.createTabsFromNavbarData(this.item);
      }
    });
  }

  sortDropdownData<T>(data: T[], selector: (item: T) => string) {
    if (data) {
      if (data) {
        data.sort((a, b) => {
          if (!selector(a) && !selector(b)) return 0; //both are empty
          if (!selector(a)) return -1;//a is empty
          if (!selector(b)) return 1; //b is empty
          if (!isNaN(Number(selector(a))) && !isNaN(Number(selector(b)))) {
            return Number(selector(a)) - Number(selector(b)); //a and b are numbers
          } if (!isNaN(Number(selector(a)))) return -1; // a is a number
          if (!isNaN(Number(selector(b)))) return 1; // b is a number
          return selector(a).localeCompare(selector(b), undefined, { sensitivity: 'base' });
        });
      }

    }
  }
}